import { render, staticRenderFns } from "./infostrafic.vue?vue&type=template&id=413b187c&scoped=true"
import script from "./infostrafic.vue?vue&type=script&lang=js"
export * from "./infostrafic.vue?vue&type=script&lang=js"
import style0 from "./infostrafic.vue?vue&type=style&index=0&id=413b187c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "413b187c",
  null
  
)

export default component.exports